import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

export interface ProductSyncBranchSummary {
    readonly total: number;
    readonly pending: number;
    readonly success: number;
    readonly error: number;
}

export interface ProductSyncResponse {
    readonly uuid: string;
    readonly fluigCode: string;
    readonly productCode: string;
    readonly description: string;
    readonly syncStatus: string;
    readonly operationType: string;
    readonly createdAt: string;
    readonly requestedBy?: string;
    readonly branchSummary?: ProductSyncBranchSummary;
}

export interface ProductSyncBranch {
    readonly uuid: string;
    readonly branchCode: string;
    readonly syncStatus: string;
    readonly errorMessage?: string;
}

export interface ProductSyncProductData {
    readonly code: string;
    readonly description: string;
    readonly type: string;
    readonly typeCode: string;
    readonly classification: string;
    readonly unitOfMeasure: string;
    readonly stockGroup: string;
    readonly defaultWarehouse: string;
    readonly origin: string;
    readonly mercosulExternalNomenclature: string;
    readonly storageLocation: string;
}

export interface ProductSyncDetailResponse {
    readonly uuid: string;
    readonly fluigCode: string;
    readonly syncStatus: string;
    readonly operationType: string;
    readonly createdAt: string;
    readonly requestedBy?: string;
    readonly productData: ProductSyncProductData;
    readonly branches: ProductSyncBranch[];
}

@Injectable({
    providedIn: 'root'
})
export class ProductSyncService {
    readonly #http = inject(HttpClient);
    readonly #apiUrl = environment.apiUrl;

    getAll(): Observable<ProductSyncResponse[]> {
        return this.#http.get<ProductSyncResponse[]>(`${this.#apiUrl}/ProductSync`);
    }

    getById(uuid: string): Observable<ProductSyncDetailResponse> {
        return this.#http.get<ProductSyncDetailResponse>(`${this.#apiUrl}/ProductSync/${uuid}`);
    }

    retryBranchBulk(uuids: string[]): Observable<any> {
        return this.#http.post(`${this.#apiUrl}/ProductSync/Branches/RetryBulk`, { uuids });
    }
}
